import React from 'react';
import PropTypes from 'prop-types';

import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai';
import Parser from 'html-react-parser';
import { Carousel } from '3d-react-carousal';

import PublicationsSection from '../publicationsSection/PublicationsSection';
import LeftImage from '../../images/project/project-image-effect-flipped.png';
import './ProjectDetails.css';
// import { blue } from '@material-ui/core/colors';

function textBold(val) {
  let text = val.split('\n');
  const array = [];
  text.map((p) => {
    if (p.split('|')[1] !== undefined) {
      text = `<span style="font-weight: 430;">${p.split('|')[0]}&nbsp;|&nbsp&nbsp;</span>${p.split('|')[1]}`;
      array.push(text);
    }
    return array;
  });
  return array;
}

const ProjectDetailsSection = ({
  authors, description, benefits, applications, ipstatus, trl, projectid, images, factsheet,
}) => {
  const trlNumber = trl.split(']')[0].split(' ')[1];
  if (trlNumber > 0 && trlNumber < 4) {
    document.body.style.setProperty('--blue', '#7DC1E8');
  }
  if (trlNumber > 4 && trlNumber < 7) {
    document.body.style.setProperty('--blue', '#0DA6FF');
  }
  if (trlNumber > 7 && trlNumber < 10) {
    document.body.style.setProperty('--blue', '#0A86CD');
  }
  const detailsDescription = textBold(description).map(paragraph => <p key={paragraph} id="detailsDescription">{Parser(paragraph)}</p>);
  const formatedBenefits = textBold(benefits).map(benefit => <p key={benefit} id="formatedBenefits">{Parser(benefit)}</p>);
  const formatedApplications = textBold(applications).map(application => <p key={application} id="formatedApplications">{Parser(application)}</p>);

  const formatedAuthors = authors.split(',').map(author => (
    <p key={author} id="formatedAuthors">
      <AiOutlineRight size={13} />
      {author.trim()}
    </p>
  ));

  const slides = [];
  if (images) {
    const imagesAux = images.split(',');
    let index = 0;
    imagesAux.map((i) => {
      const link = `https://voxarlabs.cin.ufpe.br/~voxarlabs${i.trim()}`;
      const aux = `<img src=${link} alt=${index} />`;
      index += 1;
      return slides.push(Parser(aux));
    });
  }
  const name = slides.length > 1 ? 'images' : 'image';

  const auxWidth = window.screen.width;
  let imageLeft = true;
  if (auxWidth < 768) {
    imageLeft = false;
  }

  return (
    <div id="ProjectDetailsSection">
      <div id="detailsLeft">
        <div id="researchers">
          <h2>RESEARCHERS</h2>
          {formatedAuthors}
        </div>
        { factsheet && (
          <div id="downloads">
            <h2>DOWNLOADS</h2>
            <p>
              <AiOutlineRight size={13} />
              <a href={`https://voxarlabs.cin.ufpe.br/~voxarlabs${factsheet}`} target="_blank" rel="noopener noreferrer">
              Factsheet PDF
              </a>
            </p>
            <h2>
              <AiOutlineLeft size={20} />
              <a href="/~voxarlabs/portfolio">
              Back to catalog
              </a>
            </h2>
          </div>
        )}
        { imageLeft && (
          <img src={LeftImage} alt="" />
        )}
      </div>

      <div id="detailsRight">
        <div>
          <h1>DESCRIPTION</h1>
          {detailsDescription}
        </div>
        <div>
          <h1>BENEFITS</h1>
          {formatedBenefits}
        </div>
        <div>
          <h1>APPLICATIONS</h1>
          {formatedApplications}
        </div>
        <div>
          <h1>STAGE OF DEVELOPMENT</h1>
          <p>{trl}</p>
        </div>
        <div>
          <h1>IP STATUS</h1>
          <p>{ipstatus}</p>
        </div>
        {(
          <PublicationsSection projectid={projectid} />
        )}
        { slides.length > 0
          && (
          <div className="carousel">
            <div>
              <h1 className="size">IMAGES</h1>
              <p className="size p">
                (
                {slides.length}
                {' '}
                {name}
                )
              </p>
            </div>
            <Carousel slides={slides} />
          </div>
          )
        }
      </div>
    </div>
  );
};

ProjectDetailsSection.propTypes = {
  authors: PropTypes.string.isRequired,
  images: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  benefits: PropTypes.string.isRequired,
  applications: PropTypes.string.isRequired,
  ipstatus: PropTypes.string.isRequired,
  trl: PropTypes.string.isRequired,
  projectid: PropTypes.string.isRequired,
  factsheet: PropTypes.string.isRequired,
};

export default ProjectDetailsSection;
